const mobileBackButton = document.querySelector('#mobile-back-button');
const navbarHamburger = document.querySelector('#navbar-hamburger');
const mobileHeaderClose = document.querySelector('#mobile-header-close');
const headerCollapsible = document.querySelector('.header-collapsible');

if (mobileBackButton) {
	mobileBackButton.addEventListener('click', event => {
		event.preventDefault();
		event.stopPropagation();

		window.history.back();
	});
}

if (navbarHamburger) {
	navbarHamburger.addEventListener('click', event => {
		event.preventDefault();
		headerCollapsible.classList.add('revealed');
	});
}

if (mobileHeaderClose) {
	mobileHeaderClose.addEventListener('click', event => {
		event.preventDefault();
		headerCollapsible.classList.remove('revealed');
	});
}
